export default function getItemsFromList(requisites, array) {
  if (array === null) return [];
  let result = [];
  array.forEach((i) => {
    let obj = requisites.filter((item) => item.id === +i)[0];
    result.push(obj);
  });
  return result;
}
